import styled from 'styled-components';

const CONTAINER = styled.div`
  height: 93vh;
  margin-top: 4rem;
  display: flex;
  @media screen and (max-height: 789px) {
    height: 91.5vh;
  }
`;

export default CONTAINER;
